import React, { createContext, useState } from "react";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const getMode = () => {
    return JSON.parse(localStorage.getItem("mode")) || true;
  };

  const [dark, setDark] = useState(getMode());

  const themeToggler = () => {
    setDark((prev) => !prev);
  };

  return (
    <ThemeContext.Provider value={{ dark, themeToggler }}>
      {children}
    </ThemeContext.Provider>
  );
};
